import { useUpdateIssue } from './useUpdateIssue';

export const useTogglePin = () => {
  const { mutateAsync: updateIssue } = useUpdateIssue();

  const togglePin = async (issueId: string, isPinned: boolean) => {
    const input = {
      id: issueId,
      isPinned,
    };

    return await updateIssue({ input });
  };

  return { togglePin };
};
